import { render, staticRenderFns } from "./MangelStatusSelect.vue?vue&type=template&id=6500931c&scoped=true&"
import script from "./MangelStatusSelect.vue?vue&type=script&lang=ts&"
export * from "./MangelStatusSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MangelStatusSelect.vue?vue&type=style&index=0&id=6500931c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6500931c",
  null
  
)

export default component.exports